// import React, { useState } from "react";
// import { Col, Form, Modal, Row } from "react-bootstrap";
// import SbCancelBtn, { SbAddBtn, SBSaveUpdateBtn } from "../Buttons/Buttons";
// import Select from "react-select";

// // Dropdown options
// const rigOptionsData = {
//     chesa: [{ value: "akita 525", label: "Akita 525" }],
//     "chesapeake appalachia llc": [{ value: "cactus 144", label: "Cactus 144" }],
//     "chesapeake energy": [{ value: "h&p 482", label: "H&P 482" }],
// };

// const padNameOptionsData = {
//     "akita 525": [{ value: "forecast", label: "Forecast" }],
//     "cactus 144": [{ value: "gate 010-chk-b 1286", label: "GATES 010-CHK-B 1286" }],
//     "h&p 482": [{ value: "ralph edwards f", label: "Ralph Edwards F" }],
// };

// const operatorOptions = [
//     { value: "chesa", label: "Chesa" },
//     { value: "chesapeake appalachia llc", label: "Chesapeake Appalachia L.L.C" },
//     { value: "chesapeake energy", label: "Chesapeake Energy" },
// ];

// const pOptions = [
//     { value: "Conventional", label: "Conventional" },
//     { value: "Even Wall", label: "Even Wall" },
// ]

// const ceOptions = [
//     { value: "Brine", label: "Brine" },
//     { value: "Invert", label: "Invert" },
//     { value: "Water", label: "Water" },
//     { value: "Air", label: "Air" },
//     { value: "Oil Based", label: "Oil Based" },
// ]

// const motorSizeOptions = [
//     { value: "4.75", label: "4.75" },
//     { value: "5.00", label: "5.00" },
//     { value: "6.50", label: "6.50" },
//     { value: "7.00", label: "7.00" },
// ];

// const powerSectionOptions = {
//     lobe: [
//         { value: "5/6", label: "5/6" },
//         { value: "6/7", label: "6/7" },
//         { value: "7/8", label: "7/8" }
//     ],
//     stage: [
//         { value: "12.0", label: "12.0" },
//         { value: "6.9", label: "6.9" }
//     ]
// };

// const angleOptions = [
//     { value: "0.00", label: "0.00" },
//     { value: "1.25", label: "1.25" },
//     { value: "1.75", label: "1.75" },
//     { value: "2.25", label: "2.25" },
//     { value: "2.50", label: "2.50" },
//     { value: "2.75", label: "2.75" },
// ];

// const connectionTopOptions = [
//     { value: "3 1/2", label: "3 1/2" },
//     { value: "4 1/5", label: "4 1/5" },
//     { value: "6 5/8", label: "6 5/8" },
//     { value: "7 5/8", label: "7 5/8" },
// ];

// const threadOptions = [
//     { value: "IF-Box", label: "IF-Box" },
//     { value: "IF-Pin", label: "IF-Pin" },
//     { value: "Reg-Box", label: "Reg-Box" },
//     { value: "Reg-Pin", label: "Reg-Pin" },
// ];

// const connectionBottomOptions = [
//     { value: "2 7/8", label: "2 7/8" },
//     { value: "3 1/5", label: "3 1/5" },
//     { value: "4 1/5", label: "4 1/5" },
//     { value: "6 5/8", label: "6 5/8" },
// ];
// const bendTypeOptions = [
//     { value: "adjustable", label: "Adjustable" },
//     { value: "fixed", label: "Fixed" },
// ];

// const stabilizerTypeOptions = [
//     { value: "True Slick", label: "True Slick" },
//     { value: "Slick Sleeve Stb", label: "Slick Sleeve Stb" },
//     { value: "Screw on Stb", label: "Screw on Stb" },
//     { value: "IB Stb", label: "IB Stb" },
// ];

// const stabilizerSizeOptions = [
//     { value: "5 7/8\"", label: "5 7/8\"" },
//     { value: "6\"", label: "6\"" },
//     { value: "6 1/8\"", label: "6 1/8\"" },
//     { value: "6 1/4\"", label: "6 1/4\"" },
//     { value: "7 3/8\"", label: "7 3/8\"" },
//     { value: "7 1/2\"", label: "7 1/2\"" },
// ];

// const fitRequestOptions = [
//     { value: "Need -0.002", label: "Need -0.002" },
//     { value: "STD", label: "STD" },
//     { value: "0.50 OS", label: "0.50 OS" },
//     { value: "1.00 OS", label: "1.00 OS" },
//     { value: "2.00 OS", label: "2.00 OS" },
// ]

// const AddManageOrders = (props) => {
//     const [selectedOperator, setSelectedOperator] = useState(null);
//     const [selectedRig, setSelectedRig] = useState(null);
//     const [selectedPadName, setSelectedPadName] = useState(null);
//     const [orderNumber, setOrderNumber] = useState(null);
//     const [isDisabled, setIsDisabled] = useState(false);
//     const [selectedP, setSelectedP] = useState(null);
//     const [isCeEnabled, setIsCeEnabled] = useState(false);

//     const handlePChange = (selected) => {
//         setSelectedP(selected);
//         setIsCeEnabled(true); // Enable ceOptions dropdown only when pOptions is selected
//     };

//     // Function to generate order number and disable fields
//     const handleCreateOrder = () => {
//         const generatedOrderNumber = `ORD-${Math.floor(1000 + Math.random() * 9000)}`; // Generate random Order Number
//         setOrderNumber(generatedOrderNumber);
//         setIsDisabled(true); // Disable fields after order creation
//     };

//     return (
//         <Modal show={props.open} onHide={props.handleCloseModal} className="add-rest-data-source-modal">
//             <Modal.Header closeButton>
//                 <Modal.Title>Add Roles</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Row className="customer-form-fields">
//                     <Col>
//                         <Row>
//                             {/* Operator Dropdown */}
//                             <Col md={3}>
//                                 <div>
//                                     <label>Operator</label>
//                                     <Select
//                                         className="react-select-container"
//                                         classNamePrefix="react-select"
//                                         options={operatorOptions}
//                                         placeholder="Select"
//                                         value={selectedOperator}
//                                         onChange={(selected) => {
//                                             setSelectedOperator(selected);
//                                             setSelectedRig(null); // Reset Rig when Operator changes
//                                             setSelectedPadName(null); // Reset Pad Name when Operator changes
//                                         }}
//                                         isDisabled={isDisabled} // Disable when order is created
//                                     />
//                                 </div>
//                             </Col>

//                             {/* Rig Dropdown (Disabled until an Operator is selected) */}
//                             <Col md={3}>
//                                 <div>
//                                     <label>Rig</label>
//                                     <Select
//                                         className="react-select-container"
//                                         classNamePrefix="react-select"
//                                         options={selectedOperator ? rigOptionsData[selectedOperator.value] || [] : []}
//                                         placeholder="Select"
//                                         value={selectedRig}
//                                         onChange={(selected) => {
//                                             setSelectedRig(selected);
//                                             setSelectedPadName(null); // Reset Pad Name when Rig changes
//                                         }}
//                                         isDisabled={!selectedOperator || isDisabled} // Disabled until operator is selected
//                                     />
//                                 </div>
//                             </Col>

//                             {/* Pad Name Dropdown (Disabled until a Rig is selected) */}
//                             <Col md={3}>
//                                 <div>
//                                     <label>Pad Name</label>
//                                     <Select
//                                         className="react-select-container"
//                                         classNamePrefix="react-select"
//                                         options={selectedRig ? padNameOptionsData[selectedRig.value] || [] : []}
//                                         placeholder="Select"
//                                         value={selectedPadName}
//                                         onChange={setSelectedPadName}
//                                         isDisabled={!selectedRig || isDisabled} // Disabled until rig is selected
//                                     />
//                                 </div>
//                             </Col>

//                             {/* Create Order Button */}
//                             <Col md={3}>
//                                 <label></label>
//                                 {!orderNumber ? (
//                                     <SbAddBtn btnName="Create Order" onClickEffect={handleCreateOrder} isDisabled={!selectedPadName} />
//                                 ) : (
//                                     <strong>
//                                         Order #: {orderNumber}
//                                     </strong>
//                                 )}
//                             </Col>
//                         </Row>
//                         <hr />
//                         <Row>
//                             {/* Comments Section */}
//                             <Col md={4}>
//                                 <label className="pt-2 pb-2">Comments <span className="required-asterisk">*</span></label>
//                                 <Form.Control as="textarea" rows={4} />
//                             </Col>

//                             {/* Power Section */}
//                             <Col md={4}>
//                                 <label className="pt-3 pb-2"></label>
//                                 <Select
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                     options={pOptions}
//                                     placeholder="Select"
//                                     value={selectedP}
//                                     onChange={handlePChange}
//                                 />

//                                 {/* Temp Range Section */}
//                                 <Row className="mt-2">
//                                     <label className="p-1 d-flex justify-content-center align-items-center fw-bold">Temp Range <span className="required-asterisk">*</span></label>
//                                     <Col md={6}>
//                                         <Form.Control type="text" placeholder="Min Temp" />
//                                     </Col>
//                                     <Col md={6}>
//                                         <Form.Control type="text" placeholder="Max Temp" />
//                                     </Col>
//                                 </Row>
//                             </Col>
//                             <Col md={4}>
//                                 <label className="pt-3 pb-2"></label>
//                                 <Select
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                     options={ceOptions}
//                                     placeholder="Select"
//                                     isDisabled={!isCeEnabled}
//                                 />
//                                 <Row className="mt-2">
//                                     <Col>
//                                         <label className="p-1">Qty <span className="required-asterisk">*</span></label>
//                                         <Form.Control type="number" placeholder="Enter Qty" />
//                                     </Col>
//                                 </Row>
//                             </Col>
//                         </Row>
//                         <Row>
//                             {/* New Inputs - Qty, Dyno, Inspection, Date Picker */}
//                             <Col md={3}>
//                                 {/* Date Picker */}
//                                 <label className="pt-2 pb-2">Date <span className="required-asterisk">*</span></label>
//                                 <Form.Control type="date" />
//                             </Col>
//                             <Col md={2}>
//                                 {/* Dyno Required Checkbox */}
//                                 <label></label>
//                                 <Form.Check type="checkbox" label="Dyno Req" className="mt-2" />
//                             </Col>
//                             <Col md={3}>
//                                 {/* Inspection Required Checkbox */}
//                                 <label></label>
//                                 <Form.Check type="checkbox" label="Inspection Req" className="mt-2" />
//                             </Col>
//                         </Row>
//                         <hr />
//                         <Row>
//                             <Col md={6}>
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Motor</legend>

//                                     {/* Row for Motor Size */}
//                                     <Row>
//                                         <Col md={12}>
//                                             <label>Size</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={motorSizeOptions}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>
//                             <Col md={6}>
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Power Section</legend>
//                                     <Row>
//                                         {/* Lobe Dropdown */}
//                                         <Col md={6}>
//                                             <label>Lobe</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={powerSectionOptions.lobe}
//                                             />
//                                         </Col>

//                                         {/* Stage Dropdown */}
//                                         <Col md={6}>
//                                             <label>Stage</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={powerSectionOptions.stage}
//                                             />
//                                         </Col>
//                                     </Row>
//                                     <Row>
//                                         <Col className="recomended-fit">
//                                             <label>Recomended Fit</label>
//                                             <p>-0.003</p>
//                                         </Col>
//                                     </Row>
//                                     <Row>
//                                         <Col className="recomended-fit pt-0">
//                                             <label>- Ideal Temp +</label>
//                                             <Row>
//                                                 <Col>
//                                                     <p style={{ color: "red" }}>105</p>
//                                                 </Col>
//                                                 <Col>
//                                                     <p>118</p>
//                                                 </Col>
//                                                 <Col>
//                                                     <p>-249</p>
//                                                 </Col>
//                                                 <Col>
//                                                     <p style={{ color: "red" }}>268</p>
//                                                 </Col>
//                                             </Row>
//                                         </Col>
//                                     </Row>
//                                     <Row>
//                                         <Col md={12}>
//                                             <label>Fit Request</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={fitRequestOptions}
//                                             />
//                                         </Col>
//                                     </Row>
//                                     <Row>
//                                         <Col md={12}>
//                                             <label>Rotor Material</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={powerSectionOptions.stage}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>

//                         </Row>
//                         <Row className="mt-4">
//                             <Col md={6}>
//                                 {/* Bend Type */}
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Bend</legend>
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Bend Type</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={bendTypeOptions}
//                                                 isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                         <Col md={6}>
//                                             <label>Angle</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={angleOptions}
//                                                 isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>
//                             <Col md={6}>
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Connection</legend>
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Connection (Top)</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={connectionTopOptions}
//                                                 isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                         <Col md={6}>
//                                             <label>Thread (Top)</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={threadOptions}
//                                                 isDisabled={isDisabled}
//                                             />
//                                         </Col>

//                                     </Row>
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Connection (Bottom)</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={connectionBottomOptions}
//                                                 isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                         <Col md={6}>
//                                             <label>Thread (Bottom)</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={threadOptions}
//                                                 isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>
//                         </Row>
//                         <Row>
//                             <Col md={6}>
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Stabilizer</legend>
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Stabilizer Type</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={stabilizerTypeOptions}
//                                                 isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                         <Col md={6}>
//                                             <label>Stabilizer Size</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={stabilizerSizeOptions}
//                                                 isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>
//                         </Row>
//                     </Col>
//                 </Row>
//             </Modal.Body >
//             <Modal.Footer>
//                 <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} isDisabled={isDisabled} />
//                 <SBSaveUpdateBtn btnName="Update Order" onClickEffect={props.handleNextStep} isDisabled={!orderNumber} />
//             </Modal.Footer>
//         </Modal >
//     );
// };

// export default AddManageOrders;







// import React, { useState } from "react";
// import { Col, Form, Modal, Row } from "react-bootstrap";
// import SbCancelBtn, { SbAddBtn, SBSaveUpdateBtn } from "../Buttons/Buttons";
// import Select from "react-select";
// import Swal from "sweetalert2";

// // Dropdown options
// const rigOptionsData = {
//     chesa: [{ value: "akita 525", label: "Akita 525" }],
//     "chesapeake appalachia llc": [{ value: "cactus 144", label: "Cactus 144" }],
//     "chesapeake energy": [{ value: "h&p 482", label: "H&P 482" }],
// };

// const padNameOptionsData = {
//     "akita 525": [{ value: "forecast", label: "Forecast" }],
//     "cactus 144": [{ value: "gate 010-chk-b 1286", label: "GATES 010-CHK-B 1286" }],
//     "h&p 482": [{ value: "ralph edwards f", label: "Ralph Edwards F" }],
// };

// const operatorOptions = [
//     { value: "chesa", label: "Chesa" },
//     { value: "chesapeake appalachia llc", label: "Chesapeake Appalachia L.L.C" },
//     { value: "chesapeake energy", label: "Chesapeake Energy" },
// ];

// const pOptions = [
//     { value: "Conventional", label: "Conventional" },
//     { value: "Even Wall", label: "Even Wall" },
// ]

// const ceOptions = [
//     { value: "Brine", label: "Brine" },
//     { value: "Invert", label: "Invert" },
//     { value: "Water", label: "Water" },
//     { value: "Air", label: "Air" },
//     { value: "Oil Based", label: "Oil Based" },
// ]

// const motorSizeOptions = [
//     { value: "4.75", label: "4.75" },
//     { value: "5.00", label: "5.00" },
//     { value: "6.50", label: "6.50" },
//     { value: "7.00", label: "7.00" },
// ];

// const powerSectionOptions = {
//     lobe: [
//         { value: "5/6", label: "5/6" },
//         { value: "6/7", label: "6/7" },
//         { value: "7/8", label: "7/8" }
//     ],
//     stage: [
//         { value: "12.0", label: "12.0" },
//         { value: "6.9", label: "6.9" }
//     ]
// };

// const angleOptions = [
//     { value: "0.00", label: "0.00" },
//     { value: "1.25", label: "1.25" },
//     { value: "1.75", label: "1.75" },
//     { value: "2.25", label: "2.25" },
//     { value: "2.50", label: "2.50" },
//     { value: "2.75", label: "2.75" },
// ];

// const connectionTopOptions = [
//     { value: "3 1/2", label: "3 1/2" },
//     { value: "4 1/5", label: "4 1/5" },
//     { value: "6 5/8", label: "6 5/8" },
//     { value: "7 5/8", label: "7 5/8" },
// ];

// const threadOptions = [
//     { value: "IF-Box", label: "IF-Box" },
//     { value: "IF-Pin", label: "IF-Pin" },
//     { value: "Reg-Box", label: "Reg-Box" },
//     { value: "Reg-Pin", label: "Reg-Pin" },
// ];

// const connectionBottomOptions = [
//     { value: "2 7/8", label: "2 7/8" },
//     { value: "3 1/5", label: "3 1/5" },
//     { value: "4 1/5", label: "4 1/5" },
//     { value: "6 5/8", label: "6 5/8" },
// ];
// const bendTypeOptions = [
//     { value: "adjustable", label: "Adjustable" },
//     { value: "fixed", label: "Fixed" },
// ];

// const stabilizerTypeOptions = [
//     { value: "True Slick", label: "True Slick" },
//     { value: "Slick Sleeve Stb", label: "Slick Sleeve Stb" },
//     { value: "Screw on Stb", label: "Screw on Stb" },
//     { value: "IB Stb", label: "IB Stb" },
// ];

// const stabilizerSizeOptions = [
//     { value: "5 7/8\"", label: "5 7/8\"" },
//     { value: "6\"", label: "6\"" },
//     { value: "6 1/8\"", label: "6 1/8\"" },
//     { value: "6 1/4\"", label: "6 1/4\"" },
//     { value: "7 3/8\"", label: "7 3/8\"" },
//     { value: "7 1/2\"", label: "7 1/2\"" },
// ];

// const fitRequestOptions = [
//     { value: "Need -0.002", label: "Need -0.002" },
//     { value: "STD", label: "STD" },
//     { value: "0.50 OS", label: "0.50 OS" },
//     { value: "1.00 OS", label: "1.00 OS" },
//     { value: "2.00 OS", label: "2.00 OS" },
// ]

// const AddManageOrders = (props) => {
//     const [selectedOperator, setSelectedOperator] = useState(null);
//     const [selectedRig, setSelectedRig] = useState(null);
//     const [selectedPadName, setSelectedPadName] = useState(null);
//     const [orderNumber, setOrderNumber] = useState(null);
//     const [isDisabled, setIsDisabled] = useState(false);
//     const [selectedP, setSelectedP] = useState(null);
//     const [isCeEnabled, setIsCeEnabled] = useState(false);
//     const [minTemp, setMinTemp] = useState('');
//     const [maxTemp, setMaxTemp] = useState('');
//     const [quantity, setQuantity] = useState('');
//     const [comments, setComments] = useState('');
//     const [date, setDate] = useState('');
//     const [dynoReq, setDynoReq] = useState(false);
//     const [inspectionReq, setInspectionReq] = useState(false);

//     const handlePChange = (selected) => {
//         setSelectedP(selected);
//         setIsCeEnabled(true); // Enable ceOptions dropdown only when pOptions is selected
//     };

//     // Function to generate order number and disable fields
//     const handleCreateOrder = () => {
//         const generatedOrderNumber = `ORD-${Math.floor(1000 + Math.random() * 9000)}`; // Generate random Order Number
//         setOrderNumber(generatedOrderNumber);
//         setIsDisabled(true); // Disable fields after order creation
//     };

//     const generateConfig = () => {
//         const sizes = ["7.00", "8.50", "6.75", "9.00"];
//         const ratios = ["7/8-6.9", "5/6-9.4", "6/7-8.5"];
//         const types = ["FXD-1.83", "MOV-2.1", "FLX-1.95"];
//         const tools = ['6"-SSLV', '8 1/4"-IB', '5"-MCT'];

//         const size = sizes[Math.floor(Math.random() * sizes.length)];
//         const ratio = ratios[Math.floor(Math.random() * ratios.length)];
//         const type = types[Math.floor(Math.random() * types.length)];
//         const tool = tools[Math.floor(Math.random() * tools.length)];

//         return `[${size}]-[${ratio}]-[${type}]-[${tool}]`;
//     };

//     const handleUpdateOrder = () => {
//         const config = generateConfig();
//         const orderData = {
//             operator: selectedOperator?.label || '',
//             rig: selectedRig?.label || '',
//             padName: selectedPadName?.label || '',
//             orderNumber,
//             power: selectedP?.label || '',
//             minTemp,
//             maxTemp,
//             quantity,
//             comments,
//             date,
//             dynoReq,
//             inspectionReq,
//             config
//         };

//         // Send data to parent component
//         props.onAddOrder(orderData);

//         Swal.fire({
//             title: "Success!",
//             text: `Order has been created successfully with Order Number ${config}`,
//             icon: "success",
//             confirmButtonText: "OK",
//         });

//         props.handleCloseModal(); // Close modal after saving
//     };

//     return (
//         <Modal show={props.open} onHide={props.handleCloseModal} className="add-rest-data-source-modal">
//             <Modal.Header closeButton>
//                 <Modal.Title>Add Order</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Row className="customer-form-fields">
//                     <Col>
//                         <Row>
//                             {/* Operator Dropdown */}
//                             <Col md={3}>
//                                 <div>
//                                     <label>Operator</label>
//                                     <Select
//                                         className="react-select-container"
//                                         classNamePrefix="react-select"
//                                         options={operatorOptions}
//                                         placeholder="Select"
//                                         value={selectedOperator}
//                                         onChange={(selected) => {
//                                             setSelectedOperator(selected);
//                                             setSelectedRig(null); // Reset Rig when Operator changes
//                                             setSelectedPadName(null); // Reset Pad Name when Operator changes
//                                         }}
//                                         isDisabled={isDisabled} // Disable when order is created
//                                     />
//                                 </div>
//                             </Col>

//                             {/* Rig Dropdown (Disabled until an Operator is selected) */}
//                             <Col md={3}>
//                                 <div>
//                                     <label>Rig</label>
//                                     <Select
//                                         className="react-select-container"
//                                         classNamePrefix="react-select"
//                                         options={selectedOperator ? rigOptionsData[selectedOperator.value] || [] : []}
//                                         placeholder="Select"
//                                         value={selectedRig}
//                                         onChange={(selected) => {
//                                             setSelectedRig(selected);
//                                             setSelectedPadName(null); // Reset Pad Name when Rig changes
//                                         }}
//                                         isDisabled={!selectedOperator || isDisabled} // Disabled until operator is selected
//                                     />
//                                 </div>
//                             </Col>

//                             {/* Pad Name Dropdown (Disabled until a Rig is selected) */}
//                             <Col md={3}>
//                                 <div>
//                                     <label>Pad Name</label>
//                                     <Select
//                                         className="react-select-container"
//                                         classNamePrefix="react-select"
//                                         options={selectedRig ? padNameOptionsData[selectedRig.value] || [] : []}
//                                         placeholder="Select"
//                                         value={selectedPadName}
//                                         onChange={setSelectedPadName}
//                                         isDisabled={!selectedRig || isDisabled} // Disabled until rig is selected
//                                     />
//                                 </div>
//                             </Col>

//                             {/* Create Order Button */}
//                             <Col md={3}>
//                                 <label></label>
//                                 {!orderNumber ? (
//                                     <SbAddBtn btnName="Create Order" onClickEffect={handleCreateOrder} isDisabled={!selectedPadName} />
//                                 ) : (
//                                     <strong className="d-flex align-items-center">
//                                         Order #: {orderNumber}
//                                     </strong>
//                                 )}
//                             </Col>
//                         </Row>
//                         <hr />
//                         <Row>
//                             {/* Power Section */}
//                             <Col md={4}>
//                                 <label className="pt-3 pb-2"></label>
//                                 <Select
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                     options={pOptions}
//                                     placeholder="Select"
//                                     value={selectedP}
//                                     onChange={handlePChange}
//                                 />

//                                 {/* Temp Range Section */}
//                                 <Row className="mt-2">
//                                     <label className="p-1 d-flex justify-content-center align-items-center fw-bold">Temp Range <span className="required-asterisk">*</span></label>
//                                     <Col md={6}>
//                                         <Form.Control type="text" placeholder="Min Temp" value={minTemp} onChange={(e) => setMinTemp(e.target.value)} />
//                                     </Col>
//                                     <Col md={6}>
//                                         <Form.Control type="text" placeholder="Max Temp" value={maxTemp} onChange={(e) => setMaxTemp(e.target.value)} />
//                                     </Col>
//                                 </Row>
//                             </Col>
//                             <Col md={4}>
//                                 <label className="pt-3 pb-2"></label>
//                                 <Select
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                     options={ceOptions}
//                                     placeholder="Select"
//                                     isDisabled={!isCeEnabled}
//                                 />
//                                 <Row className="mt-2">
//                                     <Col>
//                                         <label className="p-1">Qty <span className="required-asterisk">*</span></label>
//                                         <Form.Control type="number" placeholder="Enter Qty" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
//                                     </Col>
//                                 </Row>
//                             </Col>
//                             {/* Comments Section */}
//                             <Col md={4}>
//                                 <label className="pt-2 pb-2">Comments <span className="required-asterisk">*</span></label>
//                                 <Form.Control as="textarea" rows={4} value={comments} onChange={(e) => setComments(e.target.value)} />
//                             </Col>
//                         </Row>
//                         <Row>
//                             {/* New Inputs - Qty, Dyno, Inspection, Date Picker */}
//                             <Col md={3}>
//                                 {/* Date Picker */}
//                                 <label className="pt-2 pb-2">Date <span className="required-asterisk">*</span></label>
//                                 <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} />
//                             </Col>
//                             <Col md={2}>
//                                 {/* Dyno Required Checkbox */}
//                                 <label></label>
//                                 <Form.Check type="checkbox" label="Dyno Req" className="mt-2" />
//                             </Col>
//                             <Col md={3}>
//                                 {/* Inspection Required Checkbox */}
//                                 <label></label>
//                                 <Form.Check type="checkbox" label="Inspection Req" className="mt-2" />
//                             </Col>
//                         </Row>
//                         <hr />
//                         <Row>
//                             <Col md={12}>
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Motor</legend>

//                                     {/* Row for Motor Size */}
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Size</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={motorSizeOptions}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>


//                         </Row>
//                         <Row className="mt-3">
//                             <Col md={12}>
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Power Section</legend>
//                                     <Row>
//                                         {/* Lobe Dropdown */}
//                                         <Col md={6}>
//                                             <label>Lobe</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={powerSectionOptions.lobe}
//                                             />
//                                         </Col>

//                                         {/* Stage Dropdown */}
//                                         <Col md={6}>
//                                             <label>Stage</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={powerSectionOptions.stage}
//                                             />
//                                         </Col>
//                                     </Row>
//                                     <Row>
//                                         <Col className="recomended-fit">
//                                             <label>Recomended Fit</label>
//                                             <p>-0.003</p>
//                                         </Col>
//                                         <Col className="recomended-fit">
//                                             <label>- Ideal Temp +</label>
//                                             <Row>
//                                                 <Col>
//                                                     <p style={{ color: "red" }}>105</p>
//                                                 </Col>
//                                                 <Col>
//                                                     <p>118</p>
//                                                 </Col>
//                                                 <Col>
//                                                     <p>-249</p>
//                                                 </Col>
//                                                 <Col>
//                                                     <p style={{ color: "red" }}>268</p>
//                                                 </Col>
//                                             </Row>
//                                         </Col>
//                                     </Row>
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Fit Request</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={fitRequestOptions}
//                                             />
//                                         </Col>
//                                         <Col md={6}>
//                                             <label>Rotor Material</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={powerSectionOptions.stage}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>
//                         </Row>
//                         <Row className="mt-3">
//                             <Col md={12}>
//                                 {/* Bend Type */}
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Bend</legend>
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Bend Type</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={bendTypeOptions}
//                                             // isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                         <Col md={6}>
//                                             <label>Angle</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={angleOptions}
//                                             // isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>

//                         </Row>
//                         <Row className="mt-3">
//                             <Col md={12}>
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Connection</legend>
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Connection (Top)</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={connectionTopOptions}
//                                             // isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                         <Col md={6}>
//                                             <label>Thread (Top)</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={threadOptions}
//                                             // isDisabled={isDisabled}
//                                             />
//                                         </Col>

//                                     </Row>
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Connection (Bottom)</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={connectionBottomOptions}
//                                             // isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                         <Col md={6}>
//                                             <label>Thread (Bottom)</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={threadOptions}
//                                             // isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>
//                         </Row>
//                         <Row className="mt-3">
//                             <Col md={12}>
//                                 <fieldset className="border rounded p-3 customLegend">
//                                     <legend className="w-auto fw-bold">Stabilizer</legend>
//                                     <Row>
//                                         <Col md={6}>
//                                             <label>Stabilizer Type</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={stabilizerTypeOptions}
//                                             // isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                         <Col md={6}>
//                                             <label>Stabilizer Size</label>
//                                             <Select
//                                                 className="react-select-container"
//                                                 classNamePrefix="react-select"
//                                                 options={stabilizerSizeOptions}
//                                             // isDisabled={isDisabled}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </fieldset>
//                             </Col>
//                         </Row>
//                     </Col>
//                 </Row>
//             </Modal.Body >
//             <Modal.Footer>
//                 <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} isDisabled={isDisabled} />
//                 <SBSaveUpdateBtn btnName="Update Order" onClickEffect={handleUpdateOrder} isDisabled={!orderNumber} />
//             </Modal.Footer>
//         </Modal >
//     );
// };

// export default AddManageOrders;




import React, { useEffect, useRef, useState } from 'react';
import Main from '../Main';
import { Button, Col, Form, Row } from 'react-bootstrap';
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import Download from '../MainSection/Download/Download';
import "../../assets/css/modulemanagement.scss";
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal, ToggleButton, ButtonGroup } from 'react-bootstrap';
import { Stepper, Step, StepLabel, CircularProgress } from '@mui/material';
import SbCancelBtn, { SbAddBtn, SBPreviousBtn, SBSaveUpdateBtn } from '../Buttons/Buttons';
import Select from 'react-select';
import attachmentImg from '../../assets/images/attachmentImg.svg';
// import PreviewComponent from './PreviewComponent';
import Swal from 'sweetalert2';

// Dropdown options
const rigOptionsData = {
    'Operator 003': [{ value: "Rig 0157", label: "Rig 0157" }],
};

const padNameOptionsData = {
    "Rig 0157": [
        { value: "Pad 777", label: "Pad 777" },
        { value: "Pad 698", label: "Pad 698" },
        { value: "Pad 536", label: "Pad 536" },
        { value: "Pad 355", label: "Pad 355" },
        { value: "Pad 228", label: "Pad 228" },
        { value: "Pad 170", label: "Pad 170" },
        { value: "Pad 095", label: "Pad 095" },
    ],
};

const operatorOptions = [
    { value: "Operator 003", label: "Operator 003" },
    { value: "Operator 004", label: "Operator 004" },
    { value: "Operator 005", label: "Operator 005" },
    { value: "Operator 006", label: "Operator 006" },
    { value: "Operator 008", label: "Operator 008" },
    { value: "Operator 011", label: "Operator 011" },
    { value: "Operator 013", label: "Operator 013" },
    { value: "Operator 014", label: "Operator 014" },
    { value: "Operator 015", label: "Operator 015" },
    { value: "Operator 016", label: "Operator 016" },
    { value: "Operator 018", label: "Operator 018" },
];

const pOptions = [
    { value: "Conventional", label: "Conventional" },
    { value: "Even Wall", label: "Even Wall" },
]

const ceOptions = [
    { value: "Brine", label: "Brine" },
    { value: "Invert", label: "Invert" },
    { value: "Water", label: "Water" },
    { value: "Air", label: "Air" },
    { value: "Oil Based", label: "Oil Based" },
]

const motorSizeOptions = [
    { value: "4.75", label: "4.75" },
    { value: "5.00", label: "5.00" },
    { value: "5.62", label: "5.62" },
    { value: "6.50", label: "6.50" },
    { value: "6.62", label: "6.62" },
    { value: "7.00", label: "7.00" },
    { value: "7.75 x 7.00", label: "7.75 x 7.00" },
    { value: "8.00", label: "8.00" },
    { value: "8.38", label: "8.38" },
    { value: "8.38 x 8.75", label: "8.38 x 8.75" },
    { value: "9.62", label: "9.62" },
    { value: "9.62 x 8.00", label: "9.62 x 8.00" },
    { value: "9.62 x 8.75", label: "9.62 x 8.75" },
    { value: "6.25", label: "6.25" },
    { value: "6.75", label: "6.75" },
];

const powerSectionOptions = {
    lobe: [
        { value: "4/5", label: "4/5" },
        { value: "5/6", label: "5/6" },
        { value: "6/7", label: "6/7" },
        { value: "7/8", label: "7/8" },
        { value: "8/9", label: "8/9" },
    ],
    stage: [
        { value: "11.7", label: "11.7" },
        { value: "12.0", label: "12.0" },
        { value: "2.2", label: "2.2" },
        { value: "3.1", label: "3.1" },
        { value: "4.0", label: "4.0" },
        { value: "4.3", label: "4.3" },
        { value: "5.0", label: "5.0" },
        { value: "5.3", label: "5.3" },
        { value: "5.9", label: "5.9" },
        { value: "6.9", label: "6.9" },
        { value: "7.0", label: "7.0" },
        { value: "8.0", label: "8.0" },
        { value: "8.3", label: "8.3" },
        { value: "8.4", label: "8.4" },
        { value: "8.8", label: "8.8" },
        { value: "9.0", label: "9.0" },
        { value: "9.4", label: "9.4" },
        { value: "9.5", label: "9.5" },
        { value: "3.3", label: "3.3" },
        { value: "3.8", label: "3.8" },
        { value: "4.8", label: "4.8" },
        { value: "6.4", label: "6.4" },
    ]
};

const angleOptionsForAdjustable = [
    { value: "0.00", label: "0.00" },
    { value: "0.39", label: "0.39" },
    { value: "0.78", label: "0.78" },
    { value: "1.00", label: "1.00" },
    { value: "1.15", label: "1.15" },
    { value: "1.50", label: "1.50" },
    { value: "1.83", label: "1.83" },
    { value: "2.12", label: "2.12" },
    { value: "2.38", label: "2.38" },
    { value: "2.60", label: "2.60" },
    { value: "2.77", label: "2.77" },
    { value: "2.89", label: "2.89" },
    { value: "2.97", label: "2.97" },
    { value: "3.00", label: "3.00" },
];

const angleOptionsForFixed = [
    { value: "0.00", label: "0.00" },
    { value: "1.25", label: "1.25" },
    { value: "1.50", label: "1.50" },
    { value: "1.75", label: "1.75" },
    { value: "1.83", label: "1.83" },
    { value: "2.00", label: "2.00" },
    { value: "2.12", label: "2.12" },
    { value: "2.25", label: "2.25" },
    { value: "2.38", label: "2.38" },
    { value: "2.50", label: "2.50" },
]

const connectionTopOptions = [
    { value: "3 1/2", label: "3 1/2" },
    { value: "4 1/2", label: "4 1/2" },
    { value: "6 5/8", label: "6 5/8" },
    { value: "7 5/8", label: "7 5/8" },
    { value: "NC56", label: "NC56" },
    { value: "XT 39", label: "XT 39" },
];

const threadOptions = [
    { value: "IF-Box", label: "IF-Box" },
    { value: "IF-Pin", label: "IF-Pin" },
    { value: "Reg-Box", label: "Reg-Box" },
    { value: "Reg-Pin", label: "Reg-Pin" },
    { value: "XH-Pin", label: "XH-Pin" },
];

const connectionBottomOptions = [
    { value: "2 7/8", label: "2 7/8" },
    { value: "3 1/2", label: "3 1/2" },
    { value: "4 1/2", label: "4 1/2" },
    { value: "6 5/8", label: "6 5/8" },
    { value: "7 5/8", label: "7 5/8" },
    { value: "XT 39", label: "XT 39" },
    { value: "XTF", label: "XTF" },
];
const bendTypeOptions = [
    { value: "adjustable", label: "Adjustable" },
    { value: "fixed", label: "Fixed" },
];

const stabilizerTypeOptions = [
    { value: "True Slick", label: "True Slick" },
    { value: "Slick Sleeve Stb", label: "Slick Sleeve Stb" },
    { value: "Screw on Stb", label: "Screw on Stb" },
    { value: "IB Stb", label: "IB Stb" },
];

const stabilizerSizeOptions = [
    { value: "Slick", label: "Slick" },
    { value: "5 7/8\"", label: "5 7/8\"" },
    { value: "6\"", label: "6\"" },
    { value: "6 1/8\"", label: "6 1/8\"" },
    { value: "6 1/4\"", label: "6 1/4\"" },
    { value: "7 3/8\"", label: "7 3/8\"" },
    { value: "7 1/2\"", label: "7 1/2\"" },
];

const fitRequestOptions = [
    { value: "Need -0.002", label: "Need -0.002" },
    { value: "STD", label: "STD" },
    { value: "0.50 OS", label: "0.50 OS" },
    { value: "1.00 OS", label: "1.00 OS" },
    { value: "2.00 OS", label: "2.00 OS" },
]

const rotorMaterialOptions = [
    { value: "Tungsten/Carbide", label: "Tungsten/Carbide" },
    { value: "Chrome", label: "Chrome" },
]

const AddManageOrders = () => {

    const [selectedOperator, setSelectedOperator] = useState(null);
    const [selectedRig, setSelectedRig] = useState(null);
    const [selectedPadName, setSelectedPadName] = useState(null);
    const [orderNumber, setOrderNumber] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);
    const [selectedP, setSelectedP] = useState(null);
    const [isCeEnabled, setIsCeEnabled] = useState(false);
    const [minTemp, setMinTemp] = useState('');
    const [maxTemp, setMaxTemp] = useState('');
    const [quantity, setQuantity] = useState('');
    const [holeSize, setHoleSize] = useState('');
    const [comments, setComments] = useState('');
    const [date, setDate] = useState('');
    const [dynoReq, setDynoReq] = useState(false);
    const [inspectionReq, setInspectionReq] = useState(false);

    const handlePChange = (selected) => {
        setSelectedP(selected);
        setIsCeEnabled(true); // Enable ceOptions dropdown only when pOptions is selected
    };

    // Function to generate order number and disable fields
    const handleCreateOrder = () => {
        const generatedOrderNumber = `ORD-${Math.floor(1000 + Math.random() * 9000)}`; // Generate random Order Number
        setOrderNumber(generatedOrderNumber);
        setIsDisabled(true); // Disable fields after order creation
    };

    const generateConfig = () => {
        const sizes = ["7.00", "8.50", "6.75", "9.00"];
        const ratios = ["7/8-6.9", "5/6-9.4", "6/7-8.5"];
        const types = ["FXD-1.83", "MOV-2.1", "FLX-1.95"];
        const tools = ['6"-SSLV', '8 1/4"-IB', '5"-MCT'];

        const size = sizes[Math.floor(Math.random() * sizes.length)];
        const ratio = ratios[Math.floor(Math.random() * ratios.length)];
        const type = types[Math.floor(Math.random() * types.length)];
        const tool = tools[Math.floor(Math.random() * tools.length)];

        return `[${size}]-[${ratio}]-[${type}]-[${tool}]`;
    };

    const [selectedMotorSize, setSelectedMotorSize] = useState(null);

    const handleMotorSizeClick = (value) => {
        setSelectedMotorSize(value);
    };

    const isEnabled = (category, value) => {
        if (!selectedMotorSize) return true;

        const enabledLobe = ["5/6", "7/8"];
        const enabledStage = ["3.1", "5.0", "8.3"];
        const enabledBend = ["adjustable", "fixed"];

        if (category === "lobe") return enabledLobe.includes(value);
        if (category === "stage") return enabledStage.includes(value);
        if (category === "bend") return enabledBend.includes(value);
        if (category === "angle") return true;
        if (category === "stabilizer") return true;

        return false;
    };

    // const handleUpdateOrder = () => {
    //     const config = generateConfig();
    //     const orderData = {
    //         operator: selectedOperator?.label || '',
    //         rig: selectedRig?.label || '',
    //         padName: selectedPadName?.label || '',
    //         orderNumber,
    //         power: selectedP?.label || '',
    //         minTemp,
    //         maxTemp,
    //         quantity,
    //         comments,
    //         date,
    //         dynoReq,
    //         inspectionReq,
    //         config
    //     };

    //     // Send data to parent component
    //     props.onAddOrder(orderData);

    //     Swal.fire({
    //         title: "Success!",
    //         text: `Order has been created successfully with Order Number ${config}`,
    //         icon: "success",
    //         confirmButtonText: "OK",
    //     });

    //     props.handleCloseModal(); // Close modal after saving
    // };


    const navigate = useNavigate();
    const location = useLocation();
    const handleAddOrder = location.state?.handleAddOrder || []; // Default empty function

    const handleBack = () => {
        navigate(-1);
    };

    const [selectedDropdown, setSelectedDropdown] = useState(null);
    const [selectedLobe, setSelectedLobe] = useState(null);
    const [selectedStage, setSelectedStage] = useState(null);
    const [selectedBendType, setSelectedBendType] = useState(null);
    const [angleOptions, setAngleOptions] = useState([]);
    const [selectedAngle, setSelectedAngle] = useState(null);
    const [selectedConnectionTop, setSelectedConnectionTop] = useState(null);
    const [selectedConnectionThreadTop, setSelectedConnectionThreadTop] = useState(null);
    const [selectedConnectionThreadBtm, setSelectedConnectionThreadBtm] = useState(null);
    const [selectedConnectionBottom, setSelectedConnectionBottom] = useState(null);
    const [selectedStabilizerType, setSelectedStabilizerType] = useState(null);
    const [selectedStabilizerSize, setSelectedStabilizerSize] = useState(null);
    const [recommendedFit, setRecommendedFit] = useState(0);
    const [idealTempRange, setIdealTempRange] = useState([]);

    // Function to toggle dropdown visibility
    const toggleDropdown = (category) => {
        setSelectedDropdown(selectedDropdown === category ? null : category);
    };

    const handleLobeClick = (value) => {
        setSelectedLobe(value);
        setSelectedStage(null); // Reset stage selection when lobe changes
    };

    // Function to handle bend type selection
    const handleBendTypeClick = (value) => {
        setSelectedBendType(value);

        // Set the appropriate angle options
        if (value === "adjustable") {
            setAngleOptions(angleOptionsForAdjustable);
        } else if (value === "fixed") {
            setAngleOptions(angleOptionsForFixed);
        } else {
            setAngleOptions([]); // Reset if no selection
        }
    };

    const handleAngleClick = (value) => setSelectedAngle(value);
    const handleConnectionTopClick = (value) => setSelectedConnectionTop(value);
    const handleConnectionThreadTopClick = (value) => setSelectedConnectionThreadTop(value);
    const handleConnectionThreadBtmClick = (value) => setSelectedConnectionThreadBtm(value);
    const handleConnectionBottomClick = (value) => setSelectedConnectionBottom(value);
    const handleStabilizerTypeClick = (value) => setSelectedStabilizerType(value);
    const handleStabilizerSizeClick = (value) => setSelectedStabilizerSize(value);
    const handleStageClick = (value) => setSelectedStage(value);

    // const handleUpdateOrder = () => {
    //     // const config = generateConfig();
    //     const config = `${selectedMotorSize ? selectedMotorSize + " " : ""}-` +
    //         `[${selectedLobe ? selectedLobe + " " : ""}-${selectedStage ? selectedStage + " " : ""}]` +
    //         `[${selectedBendType ? (selectedBendType === "Adjustable" ? "Adj" : "FXD") : ""}-${selectedAngle ? selectedAngle + " " : ""}]` +
    //         `[${selectedStabilizerSize ? selectedStabilizerSize + " " : ""}-${selectedStabilizerType ? selectedStabilizerType + " " : ""}]`;
    //     const orderData = {
    //         operator: selectedOperator?.label || '',
    //         rig: selectedRig?.label || '',
    //         padName: selectedPadName?.label || '',
    //         orderNumber,
    //         power: selectedP?.label || '',
    //         minTemp,
    //         maxTemp,
    //         quantity,
    //         comments,
    //         date,
    //         dynoReq,
    //         inspectionReq,
    //         config
    //     };

    //     Swal.fire({
    //         title: "Success!",
    //         text: `Order has been created successfully with Order Number ${config}`,
    //         icon: "success",
    //         confirmButtonText: "OK",
    //     });

    //     // Pass new order data through navigation state
    //     navigate('/motor-builder', { state: { newOrder: orderData } });
    // };

    const [showModal, setShowModal] = useState(false);
    const [showMaterialModal, setShowMaterialModal] = useState(false);
    const [orderConfig, setOrderConfig] = useState("");
    const [orderData, setOrderData] = useState({});

    const handleUpdateOrder = () => {
        const config = `${selectedMotorSize ? selectedMotorSize + " " : ""}-` +
            `[${selectedLobe ? selectedLobe + " " : ""}-${selectedStage ? selectedStage + " " : ""}]` +
            `[${selectedBendType ? (selectedBendType === "Adjustable" ? "Adj" : "FXD") : ""}-${selectedAngle ? selectedAngle + " " : ""}]` +
            `[${selectedStabilizerSize ? selectedStabilizerSize + " " : ""}-${selectedStabilizerType ? selectedStabilizerType + " " : ""}]`;

        const newOrderData = {
            operator: selectedOperator?.label || '',
            rig: selectedRig?.label || '',
            padName: selectedPadName?.label || '',
            orderNumber,
            power: selectedP?.label || '',
            minTemp,
            maxTemp,
            quantity,
            comments,
            date,
            dynoReq,
            inspectionReq,
            config
        };

        setOrderConfig(config);
        setOrderData(newOrderData);
        setShowModal(true);  // Show Success Modal
    };

    // Function to calculate recommended fit
    useEffect(() => {
        if (holeSize) {
            let fit = parseFloat(holeSize) * -0.003; // Example formula
            setRecommendedFit(fit.toFixed(3)); // Keep 3 decimal places
        } else {
            setRecommendedFit(0);
        }
    }, [holeSize]);

    // Function to determine ideal temp range
    useEffect(() => {
        if (minTemp && maxTemp) {
            let min = parseFloat(minTemp) - 2; // Example logic
            let max = parseFloat(maxTemp) + 2;
            let warningTemps = [105, 268]; // Red-colored temp values
            setIdealTempRange([min, max, -249, warningTemps]);
        } else {
            setIdealTempRange([]);
        }
    }, [minTemp, maxTemp]);
    const flatTempRange = idealTempRange.flat(); // Flattens nested arrays

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Motor-Builder"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container' style={{ height: "78vh", overflow: "auto" }}>
                            <div className='customermanagement-table-div rest-data-source-add-page-labels'>
                                <Row className="customer-form-fields">
                                    <Col>
                                        <Row>
                                            {/* Operator Dropdown */}
                                            <Col md={3}>
                                                <div>
                                                    <label>Operator</label>
                                                    <Select
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        options={operatorOptions}
                                                        placeholder="Select"
                                                        value={selectedOperator}
                                                        onChange={(selected) => {
                                                            setSelectedOperator(selected);
                                                            setSelectedRig(null); // Reset Rig when Operator changes
                                                            setSelectedPadName(null); // Reset Pad Name when Operator changes
                                                        }}
                                                        isDisabled={isDisabled} // Disable when order is created
                                                    />
                                                </div>
                                            </Col>

                                            {/* Rig Dropdown (Disabled until an Operator is selected) */}
                                            <Col md={3}>
                                                <div>
                                                    <label>Rig</label>
                                                    <Select
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        options={selectedOperator ? rigOptionsData[selectedOperator.value] || [] : []}
                                                        placeholder="Select"
                                                        value={selectedRig}
                                                        onChange={(selected) => {
                                                            setSelectedRig(selected);
                                                            setSelectedPadName(null); // Reset Pad Name when Rig changes
                                                        }}
                                                        isDisabled={!selectedOperator || isDisabled} // Disabled until operator is selected
                                                    />
                                                </div>
                                            </Col>

                                            {/* Pad Name Dropdown (Disabled until a Rig is selected) */}
                                            <Col md={3}>
                                                <div>
                                                    <label>Pad Name</label>
                                                    <Select
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        options={selectedRig ? padNameOptionsData[selectedRig.value] || [] : []}
                                                        placeholder="Select"
                                                        value={selectedPadName}
                                                        onChange={setSelectedPadName}
                                                        isDisabled={!selectedRig || isDisabled} // Disabled until rig is selected
                                                    />
                                                </div>
                                            </Col>

                                            {/* Create Order Button */}
                                            <Col md={3}>
                                                <label></label>
                                                {!orderNumber ? (
                                                    <SbAddBtn btnName="Create Order" onClickEffect={handleCreateOrder} isDisabled={!selectedPadName} />
                                                ) : (
                                                    <strong className="d-flex align-items-center">
                                                        Order #: {orderNumber}
                                                    </strong>
                                                )}
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row>
                                            {/* Power Section */}
                                            <Col md={4}>
                                                <label className="pt-3 pb-2">Motor Type</label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    options={pOptions}
                                                    placeholder="Select"
                                                    value={selectedP}
                                                    onChange={handlePChange}
                                                />

                                                {/* Temp Range Section */}
                                                <Row className="mt-2">
                                                    <label className="p-1 d-flex justify-content-center align-items-center fw-bold">Temp Range <span className="required-asterisk">*</span></label>
                                                    <Col md={6}>
                                                        <Form.Control type="text" placeholder="Min Temp" value={minTemp} onChange={(e) => setMinTemp(e.target.value)} />
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Control type="text" placeholder="Max Temp" value={maxTemp} onChange={(e) => setMaxTemp(e.target.value)} />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md={4}>
                                                <label className="pt-3 pb-2">Mud Type</label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    options={ceOptions}
                                                    placeholder="Select"
                                                    isDisabled={!isCeEnabled}
                                                />
                                                <Row className="mt-2">
                                                    <Col>
                                                        <label className="p-1">Hole Size <span className="required-asterisk">*</span></label>
                                                        <Form.Control type="number" min={0} value={holeSize} onChange={(e) => setHoleSize(e.target.value)} />
                                                    </Col>
                                                    <Col>
                                                        <label className="p-1">Qty <span className="required-asterisk">*</span></label>
                                                        <Form.Control type="number" min={0} value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            {/* Comments Section */}
                                            <Col md={4}>
                                                <label className="pt-2 pb-2">Comments <span className="required-asterisk">*</span></label>
                                                <Form.Control as="textarea" rows={4} value={comments} onChange={(e) => setComments(e.target.value)} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            {/* New Inputs - Qty, Dyno, Inspection, Date Picker */}
                                            <Col md={3}>
                                                {/* Date Picker */}
                                                <label className="pt-2 pb-2">Date <span className="required-asterisk">*</span></label>
                                                <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} />
                                            </Col>
                                            <Col md={2}>
                                                {/* Dyno Required Checkbox */}
                                                <label></label>
                                                <Form.Check type="checkbox" label="Dyno Req" className="mt-2" />
                                            </Col>
                                            <Col md={3}>
                                                {/* Inspection Required Checkbox */}
                                                <label></label>
                                                <Form.Check type="checkbox" label="Inspection Req" className="mt-2" />
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row>
                                            <Col md={12}>
                                                {/* Row for Motor Size */}
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="inventory-container">
                                                            <div className="dropdown-filters">
                                                                <fieldset className="border rounded p-3 customLegend">
                                                                    <legend className="w-auto fw-bold">Motor</legend>
                                                                    {/* Motor Type Section */}
                                                                    <div className="filter-section">
                                                                        <div className="filter-item" onClick={() => toggleDropdown("MotorSize")}>
                                                                            Size ▼
                                                                        </div>
                                                                        <div className="filter-dropdown">
                                                                            {motorSizeOptions.map((option) => (
                                                                                <div key={option.value} className={`filter-option ${selectedMotorSize === option.value ? "selected" : ""}`}
                                                                                    onClick={() => handleMotorSizeClick(option.value)}>
                                                                                    {option.label}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        <div className="divider" />
                                                                    </div>
                                                                    <div className='motor-le-ps'>
                                                                        <p>LE : {selectedMotorSize || ""}</p>
                                                                        <p>PS : {selectedMotorSize || ""}</p>
                                                                    </div>
                                                                </fieldset>
                                                                <fieldset className="border rounded p-3 customLegend">
                                                                    <legend className="w-auto fw-bold">Power Section</legend>
                                                                    <div className="filter-section">
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("PowerLob")}>
                                                                                Lobe ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {selectedMotorSize === "6.62"
                                                                                    ? powerSectionOptions.lobe
                                                                                        .filter((option) => ["4/5", "5/6", "7/8"].includes(option.value))
                                                                                        .map((option) => (
                                                                                            <div
                                                                                                key={option.value}
                                                                                                className={`filter-option ${selectedLobe === option.value ? "selected" : ""}`}
                                                                                                onClick={() => handleLobeClick(option.value)}
                                                                                            >
                                                                                                {option.label}
                                                                                            </div>
                                                                                        ))
                                                                                    : null}
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("PowerStage")}>
                                                                                Stage ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {
                                                                                    selectedLobe
                                                                                        ? selectedLobe === "7/8"
                                                                                            ? powerSectionOptions.stage
                                                                                                .filter((option) => option.value === "6.9")
                                                                                                .map((option) => (
                                                                                                    <div key={option.value} className={`filter-option ${selectedStage === option.value ? "selected" : ""}`}
                                                                                                        onClick={() => handleStageClick(option.value)}>
                                                                                                        {option.label}
                                                                                                    </div>
                                                                                                ))
                                                                                            : powerSectionOptions.stage.map((option) => (
                                                                                                <div key={option.value} className={`filter-option ${selectedStage === option.value ? "selected" : ""}`}
                                                                                                    onClick={() => handleStageClick(option.value)}>
                                                                                                    {option.label}
                                                                                                </div>
                                                                                            ))
                                                                                        : null} {/* This ensures the dropdown remains empty initially */}
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                    </div>
                                                                    <div className='power-section-second-div'>
                                                                        <div className="recomended-fit">
                                                                            <label>Recomended Fit</label>
                                                                            <p>{recommendedFit}</p>
                                                                        </div>
                                                                        <div className="ideal-temp">
                                                                            <label>- Ideal Temp +</label>
                                                                            <div className='d-flex gap-3'>
                                                                                {/* <div>
                                                                                    <p style={{ color: "red" }}>105</p>
                                                                                </div>
                                                                                <div>
                                                                                    <p>118</p>
                                                                                </div>
                                                                                <div>
                                                                                    <p>-249</p>
                                                                                </div>
                                                                                <div>
                                                                                    <p style={{ color: "red" }}>268</p>
                                                                                </div> */}
                                                                                {flatTempRange.slice(0, 4).map((temp, index, arr) => (
                                                                                    <div key={index}>
                                                                                        <p style={{ color: index === 0 || index === arr.length - 1 ? "red" : "black" }}>
                                                                                            {temp}
                                                                                        </p>
                                                                                    </div>
                                                                                ))}

                                                                            </div>
                                                                        </div>
                                                                        <div className='power-section-select-div'>
                                                                            <div>
                                                                                <label>Fit Request</label>
                                                                                <Select
                                                                                    className="react-select-container"
                                                                                    classNamePrefix="react-select"
                                                                                    options={fitRequestOptions}
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <label>Rotor Material</label>
                                                                                <Select
                                                                                    className="react-select-container"
                                                                                    classNamePrefix="react-select"
                                                                                    options={rotorMaterialOptions}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </fieldset>
                                                                <fieldset className="border rounded p-3 customLegend">
                                                                    <legend className="w-auto fw-bold">Bend</legend>
                                                                    <div className="filter-section">
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("Bendtype")}>
                                                                                Bend Type ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {bendTypeOptions.map((option) => (
                                                                                    <div
                                                                                        key={option.value}
                                                                                        className={`filter-option ${selectedBendType === option.value ? "selected" : ""}`}
                                                                                        onClick={() => handleBendTypeClick(option.value)}
                                                                                    >
                                                                                        {option.label}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("Bendangle")}>
                                                                                Angle ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {angleOptions.length > 0
                                                                                    ? angleOptions.map((option) => (
                                                                                        <div key={option.value} className={`filter-option ${selectedAngle === option.value ? "selected" : ""}`}
                                                                                            onClick={() => handleAngleClick(option.value)}>
                                                                                            {option.label}
                                                                                        </div>
                                                                                    ))
                                                                                    : <div className="filter-option disabled"></div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                    </div>
                                                                </fieldset>
                                                                <fieldset className="border rounded p-3 customLegend">
                                                                    <legend className="w-auto fw-bold">Connection</legend>
                                                                    <div className="filter-section">
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("ConnectionTop")}>
                                                                                Top ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {connectionTopOptions.map((option) => (
                                                                                    <div key={option.value} className={`filter-option ${selectedConnectionTop === option.value ? "selected" : ""}`}
                                                                                        onClick={() => handleConnectionTopClick(option.value)}>
                                                                                        {option.label}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("ConnectionThread")}>
                                                                                Thread ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {threadOptions.map((option) => (
                                                                                    <div key={option.value} className={`filter-option ${selectedConnectionThreadTop === option.value ? "selected" : ""}`}
                                                                                        onClick={() => handleConnectionThreadTopClick(option.value)}>
                                                                                        {option.label}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("ConnectionThread")}>
                                                                                Btm ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {connectionBottomOptions.map((option) => (
                                                                                    <div key={option.value} className={`filter-option ${selectedConnectionBottom === option.value ? "selected" : ""}`}
                                                                                        onClick={() => handleConnectionBottomClick(option.value)}>
                                                                                        {option.label}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("ConnectionThread")}>
                                                                                Thread ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {threadOptions.map((option) => (
                                                                                    <div key={option.value} className={`filter-option ${selectedConnectionThreadBtm === option.value ? "selected" : ""}`}
                                                                                        onClick={() => handleConnectionThreadBtmClick(option.value)}>
                                                                                        {option.label}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                    </div>
                                                                </fieldset>
                                                                <fieldset className="border rounded p-3 customLegend">
                                                                    <legend className="w-auto fw-bold">Stabilizer</legend>
                                                                    <div className="filter-section">
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("StabilizerType")}>
                                                                                Stabilizer Type ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {stabilizerTypeOptions.map((option) => (
                                                                                    <div key={option.value} className={`filter-option ${selectedStabilizerType === option.value ? "selected" : ""}`}
                                                                                        onClick={() => handleStabilizerTypeClick(option.value)}>
                                                                                        {option.label}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                        <div className='filter-item-container'>
                                                                            <div className="filter-item" onClick={() => toggleDropdown("StabilizerSize")}>
                                                                                Stabilizer Size ▼
                                                                            </div>
                                                                            <div className="filter-dropdown">
                                                                                {stabilizerSizeOptions.map((option) => (
                                                                                    <div key={option.value} className={`filter-option ${selectedStabilizerSize === option.value ? "selected" : ""}`}
                                                                                        onClick={() => handleStabilizerSizeClick(option.value)}>
                                                                                        {option.label}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        <div className="divider" />
                                                                    </div>
                                                                </fieldset>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <div className='d-flex justify-content-end align-items-end p-2 gap-2'>

                                    <div className='d-flex justify-content-end align-items-center p-2 gap-2'>
                                        <p className='m-0'>
                                            [ {selectedMotorSize && `${selectedMotorSize} `}]-
                                            [{selectedLobe && `${selectedLobe} `}-{selectedStage && `${selectedStage} `}]
                                            [{selectedBendType && (selectedBendType === "Adjustable" ? "Adj" : "FXD")}-{selectedAngle && `-${selectedAngle} `}]
                                            [{selectedStabilizerSize && ` ${selectedStabilizerSize}`}-{selectedStabilizerType && ` ${selectedStabilizerType} `}]
                                        </p>

                                        <SBSaveUpdateBtn btnName="Update Order" onClickEffect={handleUpdateOrder} />
                                    </div>
                                    {/* Success Modal */}
                                    <Modal show={showModal} onHide={() => setShowModal(false)} centered className='add-role-modal'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Success!</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <p>Order has been created successfully with Order Number&nbsp;:&nbsp;<b>{orderNumber}</b> and the configuration is&nbsp;:&nbsp;<b>{orderConfig}</b></p>
                                            <p className="mt-3">Search for material?</p>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <SbCancelBtn btnName="No" onClickEffect={() => setShowModal(false)} />
                                            <SBSaveUpdateBtn btnName="Yes" onClickEffect={() => {
                                                setShowModal(false);
                                                setShowMaterialModal(true);
                                            }} />
                                        </Modal.Footer>
                                    </Modal>

                                    {/* Material Details Modal */}
                                    <Modal show={showMaterialModal} onHide={() => setShowMaterialModal(false)} centered className='add-role-modal'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Material Details</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="text-center">
                                            <img src="https://www.calicometal.net/img/inconel625-pipe.jpg" alt="Material" className="img-fluid mb-3" style={{ height: '150px', width: '250px' }} />
                                            <p><b>Material Num:</b>110001010</p>
                                            <p><b>Material Code:</b>[{selectedMotorSize ? selectedMotorSize + " " : ""}]
                                                [{selectedLobe ? selectedLobe + " " : ""}-{selectedStage ? selectedStage + " " : ""}]
                                                [{selectedBendType ? (selectedBendType === "Adjustable" ? "Adj" : "FXD") : ""}-{selectedAngle ? selectedAngle + " " : ""}]
                                                [{selectedStabilizerSize ? selectedStabilizerSize + " " : ""}-{selectedStabilizerType ? selectedStabilizerType + " " : ""}]</p>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <SBSaveUpdateBtn btnName="Ok" onClickEffect={() => {
                                                setShowMaterialModal(false);
                                                navigate('/motor-builder', { state: { newOrder: orderData } });
                                            }} />
                                        </Modal.Footer>
                                    </Modal>
                                </div>
                            </div>
                        </Row>
                    </div>
                </div>
            </Main>
        </div >
    );
};

export default AddManageOrders;

